import React, {useState, useEffect} from 'react';
import Box from '@mui/material/Box';
import Slider from '@mui/material/Slider';



const marks = [
  {
    value: 1,
    label: 'Basic',
  },
  {
    value: 50,
    label: 'Intermediate',
  },
  {
    value: 100,
    label: 'Advanced',
  }
];

var langMarks = [
  {
    value: 1,
    label: 'Basic',
  },
  {
    value: 50,
    label: 'conversational',
  },
  {
    value: 100,
    label: 'Fluent',
  }
]

function valuetext(value) {
  return `${value}`;
}



export default function DiscreteSliderValues(props) {

  const [sliderVal, setSliderVal] = useState(1);

  useEffect( () => {

    if(props.filter == 'langProf')
    {
      setSliderVal(props?.value == 1 ? props?.value : (props?.value-1)*50);
    }else{
      setSliderVal(props?.value == 1 ? props?.value : props?.value == 3 ? 50 : 100);
    }

  }, [props?.value])

  function valueLabelFormat(value) {
    if(props.filter === 'langProf'){
      if(value == 1) {
        return 'Basic'
      }
      else if(value == 50) {
        return 'conversational'
      }
      else if(value == 100) {
        return 'Fluent'
      }
    } else {
      if(value == 1) {
        return 'Basic'
      }
      else if(value == 50) {
        return 'Intermediate'
      }
      else if(value == 100) {
        return 'Advanced'
      }
    }
  }
  // changing thew level of skill in searchedSkills state
  const handleChange = (e) => {
    if(e.target.value === 1){
      if(props.filter === 'langProf'){
        props.onChange(1)
      } else {
        props.change( (prevState) => {
          const newValue = [...prevState]
          newValue[props.index].level = 1
          return newValue
        })
      }
    }
    else if(e.target.value === 50){
      if(props.filter === 'langProf'){
        props.onChange(2)
      } else {
        props.change( (prevState) => {
          const newValue = [...prevState]
          newValue[props.index].level = 3
          return newValue
        })
      }
    }
    else{
      if(props.filter === 'langProf'){
        props.onChange(3)
      } else {
        props.change( (prevState) => {
          const newValue = [...prevState]
          newValue[props.index].level = 5
          return newValue
        })
      }
    }
  }
  return (
    <Box  sx={{ minWidth: 220 }}>
      <Slider
        aria-label="Restricted values"
        defaultValue={1}
        value={sliderVal}
        valueLabelFormat={valueLabelFormat}
        getAriaValueText={valuetext}
        step={null}
        valueLabelDisplay="auto"
        marks={props.filter === 'langProf' ? langMarks : marks}
        onChange={handleChange}
      />
    </Box>
  );
}